import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";

export default function VertrieblerStats() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/vertriebler/stats").then((r) => setStats(r.data)); }, []);
  if (!stats) return <div className="text-falke-blue">Lade…</div>;
  return (
    <div className="space-y-6" data-testid="vertriebler-stats">
      <h1 className="text-3xl font-heading font-bold text-falke-blue">Statistik</h1>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <KPI label="Empfehlungen" val={stats.eigene} />
        <KPI label="Abschlüsse" val={stats.fertig} success />
        <KPI label="Abgelehnt" val={stats.abgelehnt} />
        <KPI label="Quote" val={`${stats.abschlussquote} %`} orange />
      </div>
    </div>
  );
}
function KPI({ label, val, success, orange }) {
  return (
    <div className="falke-card p-5">
      <div className="text-xs text-falke-blue/60 uppercase tracking-wider">{label}</div>
      <div className={`font-heading text-3xl mt-1 tabular font-bold ${success ? "text-falke-success" : orange ? "text-falke-orange" : "text-falke-blue"}`}>{val}</div>
    </div>
  );
}
